
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
// @ts-ignore
export default class PasswordErrors extends Vue {
// @ts-ignore
  @Prop({ required: true }) isEmpty!: boolean;

  @Prop({ required: true }) errorData!: { hasError: boolean; errorMessage: string };

  // @ts-ignore
  @Prop({ default: false }) invalidPassword!: boolean;

  // @ts-ignore
  @Prop({ default: false }) passwordNotMatch!: boolean;
}
